import { createClient } from "@supabase/supabase-js";
import { createTenantAwareFetch } from "./tenantTransport";
import { resolveSupabaseRuntimeConfig } from "./supabaseRuntime";

const runtime = resolveSupabaseRuntimeConfig({
  url: import.meta.env.VITE_SUPABASE_URL,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  expectedHost: import.meta.env.VITE_SUPABASE_EXPECTED_HOST,
});

export const supabase = createClient(runtime.url, runtime.anonKey, {
  global: {
    fetch: createTenantAwareFetch(),
  },
});
